// extracted by mini-css-extract-plugin
export default {"tab":"ShipmentFormTabs_tab__0+-a8","active":"ShipmentFormTabs_active__jTiCn"};